import { useEffect, useRef, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import cancelIcon from "../../assets/images/close.png";
import { useDispatch, useSelector } from "react-redux";
import { removeAdminUser } from "../../redux/slices/userSlice";

const DeleteAdminUserPopUp = ({
  open,
  handleClose,
  header,
  body,
  id,
  fetchUserManagement,
  page,
  rowId,
}) => {
  const dispatch = useDispatch();
  let { loading } = useSelector((state) => state.userManagement);

  const modalRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(450)); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.down(700)); // Tablet devices
  const [deleted, setDeleted] = useState(false);
  // const tablet = useMediaQuery(theme.breakpoints.down(1025));

  // useEffect(() => {
  //   if (open) {
  //     // Freeze background scrolling
  //     const scrollY = window.scrollY;
  //     document.body.style.position = "fixed";
  //     document.body.style.top = `-${scrollY}px`;
  //     document.body.style.left = "0";
  //     document.body.style.right = "0";
  //     document.body.style.overflow = "hidden";
  //     document.body.style.width = "100%";
  //   } else {
  //     // Re-enable background scrolling
  //     const scrollY = Math.abs(parseInt(document.body.style.top || "0", 10));
  //     document.body.style.position = "";
  //     document.body.style.top = "";
  //     document.body.style.left = "";
  //     document.body.style.right = "";
  //     document.body.style.overflow = "";
  //     document.body.style.width = "";
  //     window.scrollTo(0, scrollY); // Restore the scroll position
  //   }

  //   return () => {
  //     // Cleanup: Re-enable scrolling on unmount
  //     document.body.style.position = "";
  //     document.body.style.top = "";
  //     document.body.style.left = "";
  //     document.body.style.right = "";
  //     document.body.style.overflow = "";
  //     document.body.style.width = "";
  //   };
  // }, [open]);

  useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.focus();
    }
  }, [open]);

  useEffect(() => {
    if (deleted && !loading) {
      setDeleted(false);
      handleClose();
    } else if (loading && !deleted) {
      setDeleted(true);
    }

    // eslint-disable-next-line
  }, [loading]);

  const handleSubmit = () => {
    let data = false;
    if (rowId) data = fetchUserManagement(page, rowId);

    dispatch(removeAdminUser({ admin_user_id: id, fetchUserData: data }));
  };

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        handleClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      <Box
        ref={modalRef}
        tabIndex={-1}
        sx={{
          position: "absolute",
          top: isMobile ? "20%" : isTablet ? "20%" : "50%",
          left: "50%",
          transform:
            isMobile || isTablet ? "translateX(-50%)" : "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "1rem",
          display: "flex",
          flexDirection: "column",
          outline: 0,
          height: isMobile ? "270px" : isTablet ? "250px" : "250px",
          width: isMobile ? "250px" : isTablet ? "300px" : "520px",
          padding: isMobile || isTablet ? "25px" : "35px",
          overflowY: "auto", // Enable vertical scrolling
        }}
      >
        <Box
          sx={{
            borderRadius: "1rem 1rem 0 0",
            backgroundRepeat: "round",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile || isTablet ? "90% 10%" : "95% 5%",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Typography
              id="otp-modal-title"
              component={"h1"}
              sx={{
                fontSize: isMobile || isTablet ? "20px" : "24px", // Adjust font size for mobile
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "start",
              }}
            >
              {header}
            </Typography>
            <IconButton
              onClick={handleClose}
              sx={{ height: "2.5rem", width: "2.5rem" }}
              aria-label="Close"
            >
              <img
                style={{ height: "20px" }}
                src={cancelIcon}
                alt="close icon"
              />
            </IconButton>
          </div>
        </Box>
        <Box
          sx={{
            height: "100%",
            position: "relative",
            overflowY: "auto",
            // p: isMobile ? "1.5rem" : "5rem", // Adjust padding for mobile
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar for WebKit browsers
            },
            "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer
            "scrollbar-width": "none", // Hide scrollbar for Firefox
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontFamily: "Open Sans",
                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: 400,
                textAlign: "left",
                px: 1,
                display: "inline",
              }}
            >
              {body}
            </Typography>
          </div>
        </Box>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              borderRadius: "24px",
              padding: "12px 32px",
              minWidth: "100px",
            }}
            fullWidth={isMobile}
            onClick={handleClose}
          >
            No
          </Button>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "24px",
              padding: "12px 32px",
              minWidth: "100px",
              backgroundColor: "white",
              color: "#1460AA",
              border: "1px solid #1460AA",
            }}
            fullWidth={isMobile}
            onClick={handleSubmit}
          >
            {loading ? (
              <CircularProgress
                size={20}
                sx={{ color: "white" }}
              ></CircularProgress>
            ) : (
              "Yes"
            )}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DeleteAdminUserPopUp;
